<div class="main-banner-container" [ngClass]="headerClass" [class.disease-banner]="!!disease" [class.search-open]="isSearchOpen">
    <div class="rings-container d-print-none" [class.background-gradient--subtle-circles]="!!disease" aria-hidden="true">
        <!-- Rings and Circles -->
        <div class="circle circle1 subtle-circle--fill"></div>
        <div class="circle circle2 subtle-circle--fill"></div>
        <div class="circle circle3 subtle-circle--fill"></div>
        <div class="circle circle4 subtle-circle--fill"></div>
        <div class="circle circle-ring-1 subtle-circle--outline"></div>
        <div class="circle circle-ring-2 subtle-circle--outline"></div>
        <div class="circle circle-ring-3 subtle-circle--outline"></div>
        <div class="circle circle-ring-4 subtle-circle--outline"></div>
    </div>

    <div class="position-relative all banner-image-cover header-section d-print-block min-h-print-0" [ngClass]="headerClass">
        <div class="search-header-wrapper d-print-none" *ngIf="shouldShowSearch">
            <!-- Search Overlay -->
            <div
                class="white-overlay bg-white position-fixed w-100 vh-100"
                (click)="hide()"
                (keyup.escape)="hide()"
                [hidden]="!isSearchOpen"
                [attr.aria-hidden]="!isSearchOpen"
            ></div>

            <div class="desktop px-4 px-md-0 h-100 w-100 d-flex align-items-center" (click)="show()" [ngClass]="{ home: !isSearchOpen, 'on-top': isSearchOpen }">
                <!-- Language Toggle -->
                <div *ngIf="!isSearchOpen" class="lang-toggle container-fluid px-0 py-2 w-100 position-absolute">
                    <div class="container-xxxl my-auto d-flex align-items-center">
                        <a class="lang-button ms-auto me-1 px-3 py-1 btn btn-outline-white flex-shrink-1 fw-400" [routerLink]="languageRedirect">{{ languageBtnText }}</a>
                    </div>
                </div>
                <div class="container-xxxl">
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-10 px-0">
                            <!-- Search Input -->
                            <div class="input d-flex align-items-center py-2 px-0 text-white border-bottom border-white border-2">
                                <label class="visually-hidden" for="homepage-search">Global Search</label>
                                <input
                                    class="fs-3 fs-md-1 fs-lg-0 p-0 border-0 fw-bold text-white w-100 bg-transparent"
                                    type="text"
                                    id="homepage-search"
                                    name="desktop-global-search"
                                    [placeholder]="inputTextArticle?.title"
                                    (keyup)="updateDiseases($event.target.value)"
                                    #desktopInput
                                    (keyup.enter)="redirectToSearchPage()"
                                    (focus)="show()"
                                    autocomplete="off"
                                />
                                <button type="button" class="bg-transparent border-0 p-0 text-white" aria-label="Search" (click)="redirectToSearchPage()">
                                    <i class="icon-gard-search fs-4 fs-md-1 fs-lg-0 fw-200"></i>
                                </button>
                            </div>
                            <!-- Search Results -->
                            <div class="search-results-wrapper position-relative" *ngIf="diseases.length">
                                <div class="search-results position-absolute bg-white w-100 py-4 mt-4 overflow-auto" [hidden]="areResultsHidden || !isSearchOpen">
                                    <p class="fw-light fs-18 mb-2 px-4 my-0">Suggestions</p>
                                    <ul class="flex-column w-100 m-0 p-0 list-unstyled">
                                        <li *ngFor="let disease of diseases">
                                            <a
                                                class="d-flex px-4 py-3 text-reset text-decoration-none"
                                                tabindex="0"
                                                (keydown.enter)="redirectToDisease($event, disease)"
                                                (click)="redirectToDisease($event, disease)"
                                            >
                                                <div>
                                                    <h5 class="text-green fs-md-3" [ngClass]="[!disease.synonymString ? 'mb-0' : 'mb-2']">
                                                        {{ disease.name }}
                                                    </h5>
                                                    <div class="synonym mb-2 fs-6 fw-normal" *ngIf="disease.synonymString">
                                                        <span>Other Names: </span><span>{{ disease.synonymString }}</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="background-gradient d-print-none">
                    <!-- Gradient Circles -->
                    <div class="gradient-container">
                        <div class="circle-top-left-transparent"></div>
                        <div class="circle-top-transparent"></div>
                        <div class="circle-small-left"></div>
                        <div class="circle-bottom-left"></div>
                        <div class="circle-bottom-transparent"></div>
                        <div class="circle-top-right-transparent"></div>
                        <div class="circle-small-right"></div>
                    </div>
                </div>
            </div>

            <div class="mobile-search w-100 h-100 d-lg-none position-fixed text-white" *ngIf="isSearchOpen" [ngClass]="{ 'on-top': isSearchOpen }">
                <div class="background-gradient d-print-none" aria-hidden="true">
                    <!-- Gradient Circles -->
                    <div class="circle-mobile-top"></div>
                    <div class="circle-mobile-bottom"></div>
                </div>
                <div class="mobile-search-content h-100 position-relative">
                    <!-- Mobile Search -->
                    <button type="button" class="back-container px-4 py-4 bg-transparent border-0 text-start w-100 text-white" aria-label="Go back" (click)="hide()">
                        <div class="back d-flex align-items-center">
                            <div class="circle d-flex align-items-center justify-content-center me-2 border border-1 border-white rounded-circle">
                                <i class="icon-gard-arrow-left"></i>
                            </div>
                            <p class="fs-5 fw-200 d-inline-block mb-0">Back</p>
                        </div>
                    </button>
                    <div class="px-4">
                        <!-- Mobile Search Input -->
                        <div class="input d-flex py-2 px-0 border-bottom border-white border-2">
                            <label class="visually-hidden" for="mobile-global-search">Global Search</label>
                            <input
                                class="fs-3 p-0 bg-transparent w-100 border-0 text-white"
                                type="text"
                                id="mobile-global-search"
                                name="mobile-global-search"
                                [placeholder]="inputTextArticle?.title"
                                #mobileInput
                                [autofocus]
                                (keyup)="updateDiseases($event.target.value)"
                                (keyup.enter)="redirectToSearchPage()"
                                autocomplete="off"
                            />
                            <button type="button" class="bg-transparent border-0 p-0 text-white" aria-label="Search" (click)="redirectToSearchPage()">
                                <i class="icon-gard-search fs-4"></i>
                            </button>
                        </div>
                        <!-- Mobile Search Results -->
                        <div class="search-results pb-4" [hidden]="areResultsHidden || !isSearchOpen" *ngIf="diseases.length">
                            <h4 class="fw-light py-3 mb-0 fs-18">Suggestions</h4>
                            <ul class="flex-column w-100 m-0 p-0 list-unstyled">
                                <li *ngFor="let disease of diseases; let first = first" class="pb-3 w-100" [class.pt-2]="!first">
                                    <app-mobile-search-item class="d-block" [disease]="disease" (clickEvent)="redirectToDisease($event, disease)"></app-mobile-search-item>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="disease-header-wrapper d-print-block" *ngIf="shouldShowHeader">
            <!-- Breadcrumb and Content -->
            <nav class="breadcrumb mb-0 fs-7 text-white w-100 d-print-none" aria-label="Breadcrumb">
                <div class="container-xxxl text-white">
                    <div class="container-fluid px-lg-0 align-items-center d-flex justify-content-between">
                        <div>
                            <ul class="list-inline mb-0">
                                <li
                                    class="list-inline-item"
                                    *ngFor="let breadcrumb of breadcrumbs; let index = index; let last = last"
                                    [class.breadcrumb-last]="last"
                                    [class.breadcrumb-desktop-only]="index < breadcrumbs.length - 2"
                                    [ngClass]="{
                                        'd-inline-flex d-lg-inline-block align-items-center ms-n1 ms-lg-0': index === breadcrumbs.length - 2
                                    }"
                                >
                                    <a [routerLink]="breadcrumb.link" class="white-link" *ngIf="breadcrumb.link">
                                        <span [ngClass]="{ 'd-none d-lg-inline': index === breadcrumbs.length - 2 }">{{ breadcrumb.label }}</span>
                                        <i class="icon-gard-arrow-left text-white d-lg-none" *ngIf="index === breadcrumbs.length - 2" aria-hidden="true"></i>
                                        <span class="visually-hidden d-lg-none" *ngIf="index === breadcrumbs.length - 2">Go back</span>
                                    </a>
                                    <span *ngIf="!breadcrumb.link" aria-current="page">{{ breadcrumb.label }}</span>
                                </li>
                            </ul>
                        </div>
                        <div class="lang-btn-container d-flex align-items-center d-print-none">
                            <a *ngIf="!!spanishUrlResult" class="btn btn-outline-white spanish-button text-decoration-none" [routerLink]="spanishUrl"> Español </a>
                            <a *ngIf="englishURL" class="btn btn-outline-white spanish-button text-decoration-none" [routerLink]="englishURL"> English </a>
                            <a
                                *ngIf="showPageTranslateBtn"
                                class="btn btn-outline-white spanish-button flex-shrink-1 fw-400 text-decoration-none"
                                [routerLink]="englishToSpanishUrl || spanishToEnglishUrl"
                                >{{ translateButtonTitle }}</a
                            >
                        </div>
                    </div>
                </div>
            </nav>
            <div class="container-fluid banner-content align-items-center pt-lg-5 mt-lg-4 d-print-block">
                <div class="text-white container-xxxl">
                    <div class="row mt-4 mt-lg-0 pt-3 pt-lg-0">
                        <div class="col-xl-12 ps-3" *ngIf="!disease; else regular">
                            <!-- Main Content -->
                            <h1 class="title fw-800 fs-2 fs-md-0 mb-4" *ngIf="title">{{ title }}</h1>
                            <p
                                class="fs-md-18 my-0"
                                [class.mb-5]="shouldBufferGenericHeaderDescription"
                                [class.mb-md-0]="shouldBufferGenericHeaderDescription"
                                [innerHtml]="description"
                            ></p>
                        </div>
                        <div class="col-12 spanish" *ngIf="spanishName">
                            <p class="fs-18 text-center mb-0"><strong>¡Atención:</strong> Esta y otras páginas de enfermedades en español aún están en desarrollo!</p>
                        </div>
                        <ng-template #regular>
                            <div class="col-12 mb-4 mb-lg-5 disease-title-group">
                                <!-- Disease Title and Synonyms -->
                                <h1 class="title fw-800 fs-2 fs-md-0" [ngClass]="{ 'mb-5': !synonymList?.length }">{{ disease?.name }}</h1>
                                <dl *ngIf="synonymList?.length" class="synonyms pb-5">
                                    <dt class="fs-md-18">Other Names:&nbsp;</dt>
                                    <dd class="mb-0">
                                        <clamper [minimumHeight]="50" [text]="synonymList" maxLines="2"></clamper>
                                    </dd>
                                </dl>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="section-nav-container w-100">
                <disease-section-nav class="d-print-none" *ngIf="shouldShowTabs"></disease-section-nav>
            </div>
        </div>
    </div>
</div>
